import {default as PlayerBalanceRepository} from "./PlayerBalanceRepository"
import {httpClient} from "Config";
import  {default as PlayerBalance} from "./PlayerBalance"

export const playerBalanceRepository = new PlayerBalanceRepository(httpClient)
export const playerBalance = new PlayerBalance(playerBalanceRepository)
